import React, { Component } from 'react';
import { connect } from 'react-redux';

//Actions
import {
  apiGetVehiclesSearch,
  clearDataVehicles,
  filterVehicles,
  setVehiclesState,
} from '../../../../common/modules/vehicles/VehiclesActions';

//Components
import TextInput from '../../components/TextInput';

//Resources
import {startSelectPicker, toggleModal} from '../../resources/styles/js/custom';
import Routing from '../routing/Routing';
import { strings } from '../../../../common/resources/locales/i18n';
import VehiclesFilter from '../vehicles/components/VehiclesFilter';
import {Loading} from "../../components";
import {Link} from "react-router-dom";
import VehiclesManager from "../../../../common/modules/vehicles/VehiclesManager";
import {AsyncImage} from "../../components/AsyncImage";

class ModalFilter extends Component {

  constructor(props) {
    super(props);

    this._debouncedSearch = this._debounce(this._searchVehicles, 400);
  }


  render() {
    const { searchBox } = this.props;

    return (
      <div className="modal fade" id="modalFilter" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">

              <div className="modal-header py-4 flex-column align-items-stretch">
                <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="h5 modal-title m-0">{strings('navBar.searchFilter')}</div>
                <button id='buttonCloseModalSearch' type="button" className="close p-3" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                </div>




                <div className="input-group">
                  <TextInput
                    id='searchBox'
                    type='text'
                    placeholder={strings('placeholder.searchBox')}
                    onChange={(e) => this._handleChangeValue(e.target.id, e.target.value)}
                    value={searchBox}
                    onlyInput={true}
                  />
                  <div className="input-group-append">
                    <button className="btn btn-light border" type="submit" id="button-search">
                      <ion-icon name="search-outline"/>
                    </button>
                  </div>
                </div>


              </div>


              <div className="modal-body p-0">
                <div className="search-results d-none_">
                  {this._renderOptionsSearchResults()}
                </div>
              </div>


              {this._renderVehicleFilter()}

              <div className="modal-footer">
                <button type="button" className="btn btn-outline-secondary" onClick={() => this._deleteData()}>
                  {strings('button.eraseEverything')}
                </button>
                <button onClick={(e)=> this._onSubmit(e)} className="btn btn-sm btn-secondary">{strings('button.accept')}</button>
              </div>
          </div>
        </div>
      </div>
    )
  }

  _renderOptionsSearchResults() {
    const {isLoadingVehiclesSearch, dataVehicleSearch} = this.props;

    if (isLoadingVehiclesSearch) {
      return (<div className='pt-4 pb-3'><Loading/></div>)
    }

    if (!dataVehicleSearch) {
      return (<div/>)
    }

    if (dataVehicleSearch.length === 0) {
      return (<div className="p-4 text-center">{strings('vehicles.noFound')}</div>)
    }

    return dataVehicleSearch.map((vehicle, index) => {
      const id = VehiclesManager.getVin(vehicle)
      const name = VehiclesManager.getName(vehicle)
      const mainImage = VehiclesManager.getImageMain(vehicle)
      const cuotaPriceFormat = VehiclesManager.getCuotaPriceFormat(vehicle)
      const finalPriceFormat = VehiclesManager.getFinalPriceFormat(vehicle)

      return(
        <Link to={`${Routing.vehicleDetail}${id}`} onClick={()=> toggleModal('buttonCloseModalSearch')} className="result-item-link" key={index} >
          <div className="result-item">
            <div className="row g-3 align-items-start">
              <div className="col-auto">
                <AsyncImage
                  source={mainImage}
                  style='result-thumbnail'
                  addClassDivLoading={"pl-4 pr-2 pt-4"}
                />
              </div>
              <div className="col">
                <h5 className="result-model">{name}</h5>
                <div className="mt-2">
                  <p className="result-quote">{`${strings("models.from")} ${cuotaPriceFormat} ${strings("models.from2")}`}</p>
                  <p className="result-price mb-0">{`${strings("models.pvp")} ${finalPriceFormat}`}</p>
                </div>
              </div>
            </div>
          </div>
        </Link>
      )
    })



  }
  _renderVehicleFilter() {
    const {
      availableFilters, dataVehicles, isLoadingVehicles, maxPrice, minPrice,
      colors, fuels, transmissions, price, priceMin, specialPrice, maxCuota, minCuota, cuota, cuotaMin
    } = this.props;

    if ((dataVehicles && dataVehicles.length === 0) && (availableFilters && availableFilters.length === 0) || isLoadingVehicles) {
      return <div/>
    }

    startSelectPicker();

    return (
      <div className={'mx-3 d-lg-none'}>
        <VehiclesFilter
          availableFilters={availableFilters}
          onChange={(prop, value) => this._handleValueChangeAndFilter(prop, value)}
          maxPrice={maxPrice}
          minPrice={minPrice}
          colors={colors}
          fuels={fuels}
          transmissions={transmissions}
          price={price}
          priceMin={priceMin}
          specialPrice={specialPrice}
          maxCuota={maxCuota}
          minCuota={minCuota}
          cuota={cuota}
          cuotaMin={cuotaMin}
        />
      </div>
    )
  }

  /** PRIVATE METHODS **/
  async _clearDataVehicles() {
    await this.props.clearDataVehicles();
  }

  _deleteData() {
    this._handleChangeValue('searchBox', '');
  }

  _debounce(fn, delay) {
    let timer = null;

    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        fn(...args);
      }, delay);
    };
  }

  _handleChangeValue(prop, value) {
    this.props.setVehiclesState({prop, value});

    if (prop === 'searchBox' && value.length === 0) {
      this._handleChangeValue('dataVehicleSearch', null);
    }

    if (prop === 'searchBox' && value.length !== 0) {
      this._debouncedSearch(value);
    }

  }

  _handleValueChangeAndFilter = (prop, value) => {
    this._handleChangeValue(prop, value);

  };



  _searchVehicles = (value) => {
    this.props.apiGetVehiclesSearch(value, true)
  };


  _onSubmit(e) {
    e.preventDefault();
    if (toggleModal) toggleModal('searchMobile');
    const { history, searchBox } = this.props;

    if (searchBox === ''){
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
      return this.props.filterVehicles()
    }

    history.replace(`${Routing.vehicle}search=${searchBox}`);
    this._deleteData();
    this._clearDataVehicles()
  }

}

const mapStateToProps = ({VehiclesReducer}) => {
  const {
    availableFilters,
    dataVehicles,
    dataVehicleDetail,
    dataVehiclesOriginal,
    dataVehicleSearch,
    isLoadingVehiclesSearch,
    vehiclesCount,
    maxPrice,
    minPrice,
    colors,
    fuels,
    transmissions,
    price,
    priceMin,
    specialPrice,
    currentModelDescription,
    maxCuota,
    minCuota,
    cuota,
    cuotaMin,
    searchBox
  } = VehiclesReducer;

  return {
    availableFilters,
    dataVehicles,
    dataVehicleDetail,
    dataVehiclesOriginal,
    dataVehicleSearch,
    isLoadingVehiclesSearch,
    vehiclesCount,
    maxPrice,
    minPrice,
    colors,
    fuels,
    transmissions,
    price,
    priceMin,
    specialPrice,
    currentModelDescription,
    maxCuota,
    minCuota,
    cuota,
    cuotaMin,
    searchBox,
  };
};

const mapStateToPropsAction = {
  apiGetVehiclesSearch,
  clearDataVehicles,
  setVehiclesState,
  filterVehicles,
};

export default connect(mapStateToProps, mapStateToPropsAction)(ModalFilter);
